import React from 'react';
import { accountHook } from '../lib/domHooks';

/** İlerleme çubuğunun dolu kısmı.
 *
 * Genişlik satır içi `width` ile değil bir CSS değişkeniyle verilir
 * (`--bhs-progress`) ve sınıf onu okur (App.css `.bhs-progress-fill`). Satır
 * içi `width` panelden yazılan bir kuralla ancak `!important` ile ezilebilirdi;
 * değişken ise yalnızca değeri taşır, çizimi sınıf yapar. Dolu kısım
 * `[data-bhs-account="progress-bar"]` ile seçilir (bkz. lib/domHooks.js).
 */
const ProgressFill = ({ percent = 0, className = '' }) => {
  const value = Math.max(0, Math.min(100, Number(percent) || 0));
  return (
    <div
      className={`bhs-progress-fill ${className}`.trim()}
      style={{ '--bhs-progress': `${value}%` }}
      {...accountHook('progress-bar')}
    />
  );
};

export default ProgressFill;
